import httpService from './httpService';

const getAll = () => httpService.get('/api/employment/all');

export default { getAll };
